import { contentAi } from '@mi-front/api-clients';
import { OperationStatus } from '@mi-front/core';
import { isSocialOperationInProgress } from '../screens/content/steps/social-versions/is-social-operation-in-progress';

export function useContent(id: string) {
  return contentAi.useContentGet(id, {
    query: {
      refetchInterval: (query) => {
        const data = query.state.data;

        if (!data) {
          return false;
        }

        const shouldRefresh =
          data.pntApiResult.status === OperationStatus.IN_PROGRESS ||
          data.aiArticles.status === OperationStatus.IN_PROGRESS ||
          isSocialOperationInProgress(data);

        return shouldRefresh ? 5000 : false;
      },
    },
  });
}
